import { Theme } from '@mui/material/styles';

export const dataBoxStyles = (theme: Theme, isDark: boolean) => ({
  rowContainerWallet: {
    mt: 2,
    ml: 0
  },
  cellWallet: {
    px: 2,
    borderRadius: '6px',
    py: 1.5,
    display: 'flex',
    background: isDark
      ? 'linear-gradient(rgba(255, 255, 255, 0.02), rgba(255, 255, 255, 0.01))'
      : 'rgba(233, 240, 253, 0.5)',
    boxShadow: isDark
      ? 'rgb(0 0 0 / 20%) 0px 3px 1px -2px, rgb(0 0 0 / 14%) 0px 2px 2px 0px, rgb(0 0 0 / 12%) 0px 1px 5px 0px'
      : 'rgb(0 0 0 / 7%) 0px 8px 13px 2px',
    backdropFilter: 'blur(4px)'
  },
  dataTitle: {
    fontVariationSettings: "'wght' 400",
    [theme.breakpoints.down('md')]: { pb: 0.5 },
    [theme.breakpoints.down('sm')]: { pb: 1 },
    pb: 0.5
  },
  dataNumber: {
    pr: 0.5,
    fontVariationSettings: isDark ? "'wght' 400" : "'wght' 500",
    color: isDark ? theme.palette.text.primary : theme.palette.primary.main
  },
  dataUnit: { pb: '1px', fontVariationSettings: "'wght' 400" }
});
